module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_32.00d12afc.jpg";